import { render, staticRenderFns } from "./barrage.vue?vue&type=template&id=36d41d68"
import script from "./barrage.vue?vue&type=script&lang=js"
export * from "./barrage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports